<template>
  <div v-if="!$auth.loggedIn" class="floating-btns">
    <div
      v-if="
        getWhatsappData &&
        getWhatsappData.isWhatsAppNo &&
        getWhatsappData.number &&
        getWhatsappData.whatsAppLink &&
        dialogtext
      "
      class="whatsapptext"
    >
      <v-badge offset-x="-4" color="grey lighten-3">
        <v-icon class="closeIcon" @click="dialogtext = fasle">mdi-close</v-icon>
        <div>
          <span class="black--text mb-2 caption font-weight-bold"
            >Get an ID instantly on Whatsapp.
          </span>
          <br />
          <a
            class="text-decoration-underline caption black--text"
            @click="goToWhatsapp()"
            >Click Here Now</a
          >
        </div>
      </v-badge>
    </div>
    <v-btn
      v-if="
        getWhatsappData &&
        getWhatsappData.isWhatsAppNo &&
        getWhatsappData.number &&
        getWhatsappData.whatsAppLink
      "
      large
      class="float-whatsapp"
      fixed
      fab
      right
      color="#000000"
      aria-label="whatsapp"
      @click="goToWhatsapp()"
    >
      <v-icon size="45" color="#33e675">mdi-whatsapp</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import eventScript from '@/services/script'
export default {
  data() {
    return {
      dialogtext: true
    }
  },
  computed: {
    ...mapState({
      getWhatsappData: (state) => state.user.whatsappData
    })
  },
  methods: {
    goToWhatsapp() {
      this.landingWhatsappEventTrigger()
      if (
        this.getWhatsappData &&
        this.getWhatsappData.number &&
        this.getWhatsappData.whatsAppLink
      ) {
        window.open(this.getWhatsappData.whatsAppLink)
      }
    },
    landingWhatsappEventTrigger() {
      eventScript.landingWhatsappEventTrigger()
    },
    goToTelegram() {
      window.open(process.env.TELEGRAM_URL)
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-btns {
  .v-btn {
    right: 15px;
  }
}
</style>
